import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Welcome from "@/pages/Welcome";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import Home from "@/pages/Home";
import Chat from "@/pages/Chat";
import Scan from "@/pages/Scan";
import BreedIdentifier from "@/pages/BreedIdentifier";
import Vets from "@/pages/Vets";
import VetDetail from "@/pages/VetDetail";
import DogDetail from "@/pages/DogDetail";
import Profile from "@/pages/Profile";
import Subscription from "@/pages/Subscription";
import Reminders from "@/pages/Reminders";
import ReminderForm from "@/pages/ReminderForm";
import NotificationSettings from "@/pages/NotificationSettings";
import Emergency from "@/pages/Emergency";
import VetOnboarding from "@/pages/VetOnboarding";
import VetDashboard from "@/pages/VetDashboard";
import ForVets from "@/pages/ForVets";
import Legal from "@/pages/Legal";
import DeleteAccount from "@/pages/DeleteAccount";
import Waitlist from "@/pages/Waitlist";
import FoundingPartner from "@/pages/FoundingPartner";
import LeadsDashboard from "@/pages/LeadsDashboard";
import SmsOptIn from "@/pages/SmsOptIn";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/for-vets" element={<ForVets />} />
            <Route path="/founding-partner" element={<FoundingPartner />} />
            <Route path="/waitlist" element={<Waitlist />} />
            <Route path="/sms-optin" element={<SmsOptIn />} />
            <Route path="/legal/:doc" element={<Legal />} />
            <Route path="/delete-account" element={<DeleteAccount />} />

            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Home />} />
              <Route path="chat" element={<Chat />} />
              <Route path="chat/:sessionId" element={<Chat />} />
              <Route path="scan" element={<Scan />} />
              <Route path="breed-identifier" element={<BreedIdentifier />} />
              <Route path="vets" element={<Vets />} />
              <Route path="vets/:id" element={<VetDetail />} />
              <Route path="dogs/:id" element={<DogDetail />} />
              <Route path="profile" element={<Profile />} />
              <Route path="subscription" element={<Subscription />} />
              <Route path="reminders" element={<Reminders />} />
              <Route path="reminders/new" element={<ReminderForm />} />
              <Route path="reminders/:id" element={<ReminderForm />} />
              <Route path="notification-settings" element={<NotificationSettings />} />
              <Route path="emergency" element={<Emergency />} />
              <Route path="vet-onboarding" element={<VetOnboarding />} />
              <Route path="vet-dashboard" element={<VetDashboard />} />
              <Route path="leads" element={<LeadsDashboard />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
